module.exports = __webpack_public_path__ + "assets/d_visa-dc9d23.svg";